import React from "react";

import { cn } from "@/lib/utils";

import { type VariantProps, cva } from "class-variance-authority";
import { CommandItem as CommandItemPrimitive } from "cmdk";

export const commandItemVariants = cva(
  [
    "relative",
    "flex",
    "flex-col",
    "cursor-pointer",
    "select-none",
    "items-start",
    "rounded-sm",
    "px-2",
    "py-1.5",
    "text-body-sm",
    "outline-none",
    "bg-white",
    "data-[disabled=true]:pointer-events-none",
    "data-[disabled=true]:opacity-50",
  ],
  {
    variants: {
      variant: {
        default: [
          "hover:bg-secondary/50",
          "hover:rounded-md",
          "data-[selected=true]:bg-secondary",
        ],
        warning: [
          "rounded-md",
          "bg-warning/50",
          "hover:bg-warning",
          "data-[selected=true]:bg-warning",
        ],
      },
    },
    defaultVariants: {
      variant: "default",
    },
  },
);

interface CommandItemProps
  extends React.ComponentPropsWithoutRef<typeof CommandItemPrimitive>,
    VariantProps<typeof commandItemVariants> {}

const CommandItem = React.forwardRef<
  React.ElementRef<typeof CommandItemPrimitive>,
  CommandItemProps
>(({ className, children, variant, ...props }, ref) => (
  <CommandItemPrimitive
    ref={ref}
    className={cn(commandItemVariants({ variant, className }))}
    {...props}
  >
    {children}
  </CommandItemPrimitive>
));

CommandItem.displayName = CommandItemPrimitive.displayName;
export { CommandItem };
